var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view_container"},[_c('Header'),_c('div',{staticClass:"view_title"},[_vm._v("Terms of Service")]),_c('div',{staticClass:"terms",domProps:{"innerHTML":_vm._s(_vm.terms_linebreak)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }